import { useIntl } from "@components/Intl"
import { Price, TitleS } from "@components/Typography"
import { ChoicesArticleCombination } from "@generated"
import formatPrice from "@lib/formatPrice"
import { getRelatedCombinationUrl } from "@lib/get-related-combination-url"
import { NormalizedRelatedCombination } from "@lib/hooks/helpers/get-normalized-related-combinations"
import { getCustomizeUrl } from "@screens/product/helpers/get-customize-url"
import Link from "next/link"
import React, { useState } from "react"
import { RelatedCombinationCardButtons } from "./Buttons"
import { RelatedCombinationCardImages } from "./Images"
import { RelatedCombinationCardProductThumbnails } from "./ProductThumbnails"
import * as S from "./elements"

type Props = NormalizedRelatedCombination & {
  relatedCombinationId: string
  prefix: string
  suffix: string
}

const RelatedCombinationCard: React.FC<Props> = ({
  relatedCombinationId,
  prefix,
  suffix,
  combination,
  variants,
}) => {
  const [activeProduct, setActiveProduct] =
    useState<ChoicesArticleCombination>(combination)
  const { messages, locale } = useIntl()
  const allProducts = [combination, ...variants]
  const hasLifestyleImage = !!activeProduct.images[1]
  const customizeUrl = getCustomizeUrl(
    activeProduct,
    activeProduct.product_group as any
  )

  const as = getRelatedCombinationUrl(
    prefix,
    relatedCombinationId,
    activeProduct
  )

  return (
    <div>
      <S.Parent hasLifestyleImage={hasLifestyleImage}>
        <Link
          as={`/${locale}${as}/${suffix}`}
          href={`/${locale}${messages.navigation.collectionProductDetail.url}`}
          passHref
        >
          <S.Anchor title={`${messages.global.view} ${activeProduct.name}`}>
            <S.Content>
              <TitleS as="h3">{activeProduct.name}</TitleS>
              <Price as="span">
                {activeProduct.price && formatPrice(activeProduct.price)}
              </Price>
            </S.Content>
            <RelatedCombinationCardImages images={activeProduct.images} />
          </S.Anchor>
        </Link>
        <RelatedCombinationCardButtons
          customizeUrl={customizeUrl}
          activeProduct={activeProduct}
        />
      </S.Parent>
      <RelatedCombinationCardProductThumbnails
        products={allProducts}
        handleSelect={(id: string) => handleSelect(id)}
        activeProductId={activeProduct.id}
      />
    </div>
  )

  function handleSelect(id: string) {
    const product = allProducts.find((p) => p.id === id)
    if (product) {
      setActiveProduct(product)
    }
  }
}

export default RelatedCombinationCard
